import { createToast } from "@/utils";
import {
  Badge,
  Button,
  Dialog,
  ErrorMessage,
  FeatherIcon,
  FormControl,
  frappeRequest,
  Input,
  resourcesPlugin,
  setConfig,
  TextInput,
  Tooltip,
} from "frappe-ui";
import { createPinia } from "pinia";
import { createApp } from "vue";
import App from "./App.vue";
import "./index.css";
import { router } from "./router";
import { socket } from "./socket";
import { session } from "./composables/session";
import translationPlugin from "./translation";

import { registerDokosUiComponents } from "@/dokos-ui/register";

import { useSelectedCustomer } from "@/composables/useCustomer"

const GLOBAL_COMPONENTS = {
  FBadge: Badge,
  FButton: Button,
  FDialog: Dialog,
  FErrorMessage: ErrorMessage,
  FeatherIcon: FeatherIcon,
  FFormControl: FormControl,
  FInput: Input,
  FTooltip: Tooltip,
  FTextInput: TextInput,
};


let frappeRequestWithHeader = options => {
  let newOptions = options || {};
  newOptions.headers = options.headers || {};

  const customer = useSelectedCustomer().value;
  if (customer) {
    newOptions.headers["X-Webshop-Customer"] = encodeURIComponent(customer);
  }

  return frappeRequest(newOptions);
};

setConfig("resourceFetcher", frappeRequestWithHeader);
setConfig("translatedMessages", window.translatedMessages || {});
setConfig("fallbackErrorHandler", (error) => {
  if (error.exc_type == "PermissionError") {
    router.push("/login")
  }
  console.log(JSON.parse(JSON.stringify(error)))
  createToast({
    title: error.exc_type || "Error",
    text: (error.messages || []).join(", "),
    icon: "alert-triangle",
    iconClasses: "text-red-500",
  });
});

const pinia = createPinia();
const app = createApp(App);

app.use(resourcesPlugin);
app.use(pinia);
app.use(router);
app.use(translationPlugin);

for (const c in GLOBAL_COMPONENTS) {
  app.component(c, GLOBAL_COMPONENTS[c]);
}

registerDokosUiComponents(app)

app.provide("$socket", socket)

app.config.globalProperties.$socket = socket;
app.config.globalProperties.$toast = createToast;
app.config.globalProperties.$session = session;

if (import.meta.env.DEV) {
  frappeRequest({
    url: "/api/method/bookings.www.bookings_ui.index.get_context_for_dev",
  }).then((values) => {
    for (let key in values) {
      window[key] = values[key];
    }
    if (window.translated_messages) {
      try {
        let msgs = typeof window.translated_messages === "string" ? JSON.parse(window.translated_messages) : window.translated_messages;
        setConfig("translatedMessages", msgs);
        window.translatedMessages = msgs;
      } catch(e) {}
    }
    app.mount("#app");
  });
} else {
  app.mount("#app");
}
